'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var themes = require('@wow/themes');

const {
  textStyles: {
    labelMd
  },
  colors: {
    error,
    grey
  }
} = themes.themeChakra;
const baseStyle = Object.assign(Object.assign({}, labelMd), {
  color: grey[120],
  marginBottom: '0px',
  _invalid: {
    color: error[100]
  },
  _disabled: {
    opacity: 0.4
  }
});
const FormLabelChakra = {
  baseStyle
};

exports.FormLabelChakra = FormLabelChakra;
